                    <div class="padding-top-20px padding-bottom-30px fhlb-blue-font">
                        <strong>{{cmsModel.BorrowerInformationText}}</strong>
                    </div>

                    <!-- Borrower Section -->

                    <div class="border-bottom-dashed">
                        <div class="row">
                            <div class="col-sm-7">

                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.BorrowerFirstName}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerFirstName}}
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.BorrowerMiddleInitial}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerMiddleInitial}}
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.BorrowerLastName}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerLastName}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-5">
                                <div class="row padding-top-7px"  *ngIf="isXtraDC">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.BorrowerSuffix}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerSuffix}}
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                  <div class="col-sm-6 text-align-right-sm">
                                    <label class="control-label margin-left--5px padding-top-10px">{{cmsModel.BorrowerSSN}}</label>
                                  </div>
                                  <div class="col-sm-6 padding-left-0px padding-top-30px feedback-display-font padding-top-35px">
                                    {{ bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerSSN | maskSsn }}
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- CoBorrowers Section (dynamic, no duplication) -->
                    <ng-container *ngFor="let coBorrower of getCoBorrowers(); let idx = index">
                        <div class="border-bottom-dashed">
                            <div class="padding-top-20px padding-bottom-30px fhlb-blue-font">
                                <strong>{{cmsModel.CoBorrowerText}} {{ idx + 1 }}</strong>
                            </div>
                            <div class="row">
                                <div class="col-sm-7">
                                    <div class="row padding-top-7px">
                                        <div class="col-sm-6 text-align-right-sm">
                                            <label class="control-label">{{cmsModel.CoBorrowerText}} #{{ idx + 1 }}
                                                {{cmsModel.FirstNameText}}:</label>
                                        </div>
                                        <div class="col-sm-6 padding-left-0px feedback-display-font">
                                            {{coBorrower.firstName}}
                                        </div>
                                    </div>
                                    <div class="row padding-top-7px">
                                        <div class="col-sm-6 text-align-right-sm">
                                            <label class="control-label">{{cmsModel.CoBorrowerText}} #{{ idx + 1 }}
                                                {{cmsModel.MiddleInitialText}}:</label>
                                        </div>
                                        <div class="col-sm-6 padding-left-0px feedback-display-font">
                                            {{coBorrower.middleInitial}}
                                        </div>
                                    </div>
                                    <div class="row padding-top-7px">
                                        <div class="col-sm-6 text-align-right-sm">
                                            <label class="control-label">{{cmsModel.CoBorrowerText}} #{{ idx + 1 }}
                                                {{cmsModel.LastNameText}}:</label>
                                        </div>
                                        <div class="col-sm-6 padding-left-0px feedback-display-font">
                                            {{coBorrower.lastName}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <div class="row padding-top-7px"  *ngIf="isXtraDC">
                                        <div class="col-sm-6 text-align-right-sm">
                                            <label class="control-label">{{cmsModel.CoBorrowerText}} #{{ idx + 1 }}
                                                {{cmsModel.SuffixText}}:</label>
                                        </div>
                                        <div class="col-sm-6 padding-left-0px feedback-display-font">
                                            {{coBorrower.suffix}}
                                        </div>
                                    </div>
                                    <div class="row padding-top-7px">
                                        <div class="col-sm-6 text-align-right-sm">
                                            <label
                                                class="control-label margin-left--5px padding-top-10px">{{cmsModel.CoBorrowerText}}
                                                #{{ idx + 1 }} {{cmsModel.SSNText}}:</label>
                                        </div>
                                        <div
                                            class="col-sm-6 padding-left-0px padding-top-30px feedback-display-font padding-top-35px">
                                            {{coBorrower.ssn | maskSsn}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Property Section -->

                    <div class="border-bottom-dashed">
                        <div class="padding-top-20px padding-bottom-30px fhlb-blue-font">
                            <strong>{{cmsModel.PropertyInformationText}}</strong>
                        </div>
                        <div class="row">
                            <div class="col-sm-7">

                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.PropertyAddress}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font wordWrap">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyAddress}}
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.City}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font wordWrap">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyCity}}
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.State}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyState}}
                                    </div>
                                </div>

                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.ZipCode}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyZipCode}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-5">
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.PropertyType}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                         {{getPropertyTypeForDisplay(bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyType)}}
                                   
                                    </div>
                                </div>
                                <div class="row padding-top-7px" *ngIf="isXtraDC">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.NumberOfUnits}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font ">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyNumOfUnits}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Loan Information Section -->
                    <div class="padding-bottom-20px">
                        <div class="padding-top-20px padding-bottom-30px fhlb-blue-font">
                            <strong>{{cmsModel.LoanInformationText}}</strong>
                        </div>
                        <div class="row">
                            <div class="col-sm-7">
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.LoanPurpose}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{getLoanPurposeForDisplay(bestEffortsDeliveryData?.bestEffortsDeliveryData[0].loanPurpose)}}
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.Occupancy}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].occupancy}}
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.SubordinateFinancingAmount}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].subordinateFinancingAmount
                                        |
                                        currency}}
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.AppraisedValue}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px  feedback-display-font">
                                        {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].purchasePrice |
                                        currency}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-5 padding-top-7px">
                                <div class="row padding-bottom-10px">
                                    <div class="col-sm-6 control-label text-align-right">
                                        <label>{{cmsModel.LTVText}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px form-control-static">
                                        <span class="feedback-display-font padding-left-0px ">
                                            {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].ltv || '00.00'}} %
                                        </span>
                                    </div>
                                </div>
                                <div class="row padding-bottom-10px padding-top-7px">
                                    <div class="col-sm-6 control-label text-align-right">
                                        <label>{{cmsModel.TLTVText}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px form-control-static">
                                        <span class="feedback-display-font padding-left-0px ">
                                            {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].tltv || '00.00'}} %
                                        </span>
                                    </div>
                                </div>
                                <div class="row padding-top-7px">
                                    <div class="col-sm-6 text-align-right-sm">
                                        <label class="control-label">{{cmsModel.Comments}}</label>
                                    </div>
                                    <div class="col-sm-6 padding-left-0px feedback-display-font text-word-wrap ">
                                         {{ dcExistingModel.deliveryCommitment.comments}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>